module.exports = __webpack_public_path__ + "static/17-42710068366ed9fc5fd95c00509dc1a1.jpg";